const base64ToBlob = (base64: string, mimeType: string): Blob => {
  const byteCharacters = atob(base64); // Decode base64 to binary string
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: mimeType });
};

function triggerDownload(base64String: string, filename: string, mimeType: string): void {
  const blob = base64ToBlob(base64String, mimeType);
  const url = URL.createObjectURL(blob); // Create a URL for the blob in memory

  // Create a temporary anchor element
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = filename; // Set the default file name
  
  // Append link to body, click it, and remove it
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  // Clean up the object URL after the download is initiated
  URL.revokeObjectURL(url);
}

export { triggerDownload };